import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=675b4def&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675b4def')) {
      api.createRecord('675b4def', component.options)
    } else {
      api.reload('675b4def', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=675b4def&", function () {
      api.rerender('675b4def', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2skzpbdhs6hO3/JS/comp/seasonprices.vue"
export default component.exports